import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Auth
import { auth } from "./../firebase/firebase";

function* handleInit(action) {
  //Set device width watcher
  if (
    window.innerWidth <= 450 ||
    (window.screen.availWidth < 450 &&
      window.screen.orientation.type === "portrait-primary")
  ) {
    yield put({ type: ACTIONS.CHECK_DEVICE, payload: "mobile" });
  } else if (window.innerWidth > 450 && window.innerWidth <= 1024) {
    yield put({ type: ACTIONS.CHECK_DEVICE, payload: "tablet" });
  } else {
    yield put({ type: ACTIONS.CHECK_DEVICE, payload: "desktop" });
  }

  //Get location
  if ("geolocation" in navigator) {
    // check if geolocation is supported/enabled on current browser
    yield navigator.geolocation.getCurrentPosition(
      function success(position) {
        const lat = position.coords.latitude;
        const lon = position.coords.longitude;
        const apiKey = "3186cb735a358098084a4f92a6042f27";
        const url = `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${apiKey}&units=imperial`;

        //Get weather data
        fetch(url)
          .then(res => res.json())
          .catch(err => {
            console.log(err);
          })
          .then(data =>
            action.dispatch({ type: ACTIONS.FETCH_WEATHER, payload: data })
          )
          .catch(err =>
            action.dispatch({ type: ACTIONS.FETCH_WEATHER, payload: err })
          );
      },
      function error(error_message) {
        // for when getting location results in an error
        console.error(
          "An error has occured while retrieving location",
          error_message
        );
      }
    );
  } else {
    // geolocation is not supported
    // get your location some other way
    console.log("geolocation is not enabled on this browser");
  }

  // IF APP DID NOT RUN INIT YET

  //Set user watcher/dispatcher
  yield auth.onAuthStateChanged(user => {
    if (!user) {
      //Remove authentication flag
      action.dispatch({ type: ACTIONS.IS_AUTHENTICATED, payload: false });
    }
    action.dispatch({ type: ACTIONS.SET_AUTH, payload: user });

    //If user present, trigger database action to get user info
    if (user) {
      //Get user info from db
      action.dispatch({
        type: ACTIONS.HIT_DB,
        meta: {
          data: user,
          dispatch: action.dispatch,
          filter: "fetch_user",
          uUID: user.uid
        }
      });
    }

    //Sync db watchers
    if (user) {
      action.dispatch({
        type: ACTIONS.DB_SYNC,
        uid: user.uid
      });
    }

    //Check to see if creation time and login time are identical
    //(determines signup auth problems)
    if (user) {
      if (user.metadata.a !== user.metadata.b) {
        action.dispatch({
          type: ACTIONS.IS_AUTHENTICATED,
          payload: user ? true : false
        });
      }
    }
  });
}

export function* initWatcher() {
  yield takeEvery(ACTIONS.INIT, handleInit);
}



// WEBPACK FOOTER //
// ./src/sagas/init.js